// export type Plate = {
//   a: string; // 3 digits
//   b: string; // letter
//   c: string; // 2 digits
//   r: string; // region
// };

// export function TransformPlateNumber(input: string): Plate | null {
//   if (!input) return null;

//   // Convert Persian/Arabic digits to English
//   const normalized = input
//     .replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString())
//     .replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d).toString())
//     // Normalize separators
//     .replace(/[ـ–—-]+/g, '-')
//     .replace(/\s+/g, ' ')
//     .trim();

//   // Matches:
//   // ایران 88 - 414 ج 87
//   // شخصي ايران 88 - 414ج87
//   // شخصی ایران 11 ــ 636ق11
//   const match = normalized.match(/ایران\s*(\d+)\s*-\s*(\d+)\s*([^\d\s])\s*(\d+)/);

//   if (!match) return null;

//   return {
//     r: match[1],
//     a: match[2],
//     b: match[3],
//     c: match[4],
//   };
// }

// ===============

// export type Plate = {
//   a: string;
//   b: string;
//   c: string;
//   r: string;
// };

// export function TransformPlateNumber(input: string): Plate | null {
//   if (!input) return null;

//   const normalized = input
//     .replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString())
//     .replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d).toString())
//     .replace(/[ـ–—−]+/g, '-')
//     .replace(/\s+/g, ' ')
//     .trim();

//   // Keep only everything after "ایران"
//   const idx = normalized.indexOf('ایران');
//   if (idx === -1) return null;

//   const plate = normalized.slice(idx + 'ایران'.length).trim();

//   // Matches:
//   // 88 - 414ج87
//   // 88 - 414 ج 87
//   // 11-636ق11
//   const match = plate.match(/^(\d+)\s*-\s*(\d+)\s*([\u0600-\u06FF])\s*(\d+)$/);

//   if (!match) {
//     console.log(normalized);
//     console.log(plate);
//     return null;
//   }

//   return {
//     r: match[1],
//     a: match[2],
//     b: match[3],
//     c: match[4],
//   };
// }

// ====================

// export type Plate = {
//   a: string;
//   b: string;
//   c: string;
//   r: string;
// };

// export function TransformPlateNumber(input: string): Plate | null {
//   if (!input) return null;

//   const normalized = input
//     .replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString())
//     .replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d).toString())
//     .replace(/[\u200c\u200d\u200e\u200f]/g, '') // remove invisible chars
//     .replace(/\s+/g, ' ')
//     .trim();

//   // Extract: region, 3 digits, Persian letter, 2 digits
//   const match = normalized.match(/(\d+).*?(\d{3})\s*([\u0600-\u06FF])\s*(\d{2})/);

//   if (!match) return null;

//   return {
//     r: match[1],
//     a: match[2],
//     b: match[3],
//     c: match[4],
//   };
// }

// ==================

export type Plate = {
  a: string;
  b: string;
  c: string;
  r: string;
};

export function TransformPlateNumber(input?: string): Plate | null {
  if (!input) return null;

  // Persian/Arabic digits -> English
  const normalized = input
    .replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString())
    .replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d).toString())
    .replace(/[\u200c\u200d\u200e\u200f]/g, '');

  // Find all number groups
  const numbers = normalized.match(/\d+/g);

  // Find Persian words/letters
  const words = normalized.match(/[آ-ی]+/g);

  if (!numbers || numbers.length < 3 || !words) return null;

  // Last Persian word is the plate letter/code
  const letter = words[words.length - 1];

  return {
    r: numbers[0],
    a: numbers[1],
    b: letter,
    c: numbers[2],
  };
}

// ==================================
// export type Plate = {
//   a: string;
//   b: string;
//   c: string;
//   r: string;
// };

// export function TransformPlateNumber(input?: string): Plate | null {
//   if (!input) return null;

//   const normalized = input
//     .replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString())
//     .replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d).toString())
//     .replace(/[\u200c\u200d\u200e\u200f]/g, '')
//     .replace(/ي/g, 'ی')
//     .replace(/ك/g, 'ک');

//   const match = normalized.match(/(\d{2}).*?(\d{3})([آ-ی]+)(\d{2})/);

//   if (!match) return null;

//   return {
//     r: match[1],
//     a: match[2],
//     b: match[3],
//     c: match[4],
//   };
// }
